import { jsx } from "react/jsx-runtime";
import React from "react";
var question_mark_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.4175 8.6142c.5274-.433 1.3054-.3594 1.7423.1648.459.551.3576 1.375-.2214 1.7981l-.8634.6309a2.6227 2.6227 0 0 0-1.0753 2.1176v.676h2v-.676c0-.5376.7495-.8639 1.1187-1.1338 1.5112-1.1043 1.776-3.2553.5778-4.6931-1.1403-1.3684-3.171-1.5606-4.5477-.4304L8.8232 8.1562l1.269 1.5458 1.3253-1.0878zm1.8322 8.145c0 .6903-.5596 1.25-1.25 1.25-.6903 0-1.25-.5597-1.25-1.25 0-.6904.5597-1.25 1.25-1.25.6904 0 1.25.5596 1.25 1.25z" })];
};
export {
  question_mark_default as default
};
